import React, { useState } from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import ConfirmAction from "MODULES/shared/components/ConfirmAction/ConfirmAction";
import { update } from "MODULES/SalesOrders/actions";
import { connect } from "react-redux";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { EXPORT_HOLD } from "MODULES/Receiving/constants";

function RemoveExportHold({ onConfirm, salesOrder }) {
  const [visible, setVisible] = useState(false);

  if (!salesOrder.get(EXPORT_HOLD)) {
    return null;
  }

  return (
    <DropDownItem onClick={() => setVisible(true)}>
      <Icon name="check" fixed />
      &nbsp;Remove Denied Party Hold
      <ConfirmAction
        onConfirm={onConfirm}
        close={() => setVisible(false)}
        open={visible}
        btnText="Remove Denied Party Hold"
        cancelText="Cancel"
        icon={<i className="fa fa-fw fa-check" />}
      >
        <strong>Heads up!</strong>
        &nbsp; Are you sure you want to remove the Denied Party Hold?
      </ConfirmAction>
    </DropDownItem>
  );
}

export default connect(undefined, dispatch => ({
  onConfirm: () => dispatch(update({ export_hold: false }))
}))(withSalesOrder(RemoveExportHold));

RemoveExportHold.propTypes = {
  onConfirm: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/RemoveExportHold/RemoveExportHold.jsx